import { Box, chakra, Flex, VStack } from "@chakra-ui/react";

export const FileCardContainer = chakra(Box, {
  baseStyle: {
    mt: "4",
    p: "4",
    border: "1px solid #E2E8F0",
    borderRadius: "lg",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    transition: "all 0.2s",
    cursor: "pointer",
    _hover: {
      borderColor: "#5A6FA8",
      boxShadow: "0 2px 8px rgba(64, 89, 155, 0.1)",
      transform: "translateY(-1px)",
    },
    _selected: {
      borderColor: "#40599B",
      bg: "#F0F4F8",
      boxShadow: "0 4px 12px rgba(64, 89, 155, 0.15)",
    },
  },
});

export const StatusContainer = chakra(Box, {
  baseStyle: {
    px: "3",
    py: "1",
    borderRadius: "full",
    border: "1px solid",
    fontSize: "xs",
    fontWeight: "medium",
  },
});

export const FileNameContainer = chakra(Flex, {
  baseStyle: {
    flexDirection: "row",
    m: "0",
    w: "100%",
  },
});

export const UploadAreaContainer = chakra(Box, {
  baseStyle: {
    display: "flex",
    gap: "6",
    backgroundColor: "white",
    borderRadius: "8px",
    border: "2px solid #CDD6DC99",
    padding: "24px",
  },
});

export const MainContainer = chakra(VStack, {
  baseStyle: {
    px: "30px",
    py: "12px",
    w: "100%",
    spacing: "6",
    align: "stretch",
  },
});
